import { GET_DATA_SOURCES, SET_ACTIVE_MODULE, SET_CONFIG_COMPLETED, SET_DATA_INGESTION_WSCLIENT, SET_AIRFLOW_USER_FLAG,SET_DATA_SOURCES, SET_INGESTION_BUTTON, SET_INGESTION_DATA, SET_INGESTION_FAILED_STATUS_FLAG, SET_INGESTION_PAUSE_STATUS_FLAG, SET_INGESTION_PROCESS_SWITCH_STATUS,SET_INGESTION_SWITCH_STATUS, SET_MODULE_INFO,SET_USER_INFO, UPDATE_SUBMODULE_STATUS, SET_WORKFLOW_PANEL_FLAG } from "../actions/types";

export const initialState = {
  dataSourcesDetails: [],
  ingestionData: [],
  wsClient: null,
  subModuleStatus: true,
  moduleInfo:{},
  userInfo:{},
  airflowUserFlag:false,
  activeModule: 'Data Extraction',
  ingestionProcessSwitchFlag: false,
  ingestionSwitchFlag: false,
  ingestionButton: null,
  failedStatusFlag:false,
  pauseFlag:false,
  configCompleted:null,
  hideWorkflowPanel:false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DATA_SOURCES:
      return {
        ...state,
        dataSourcesDetails: action.payload,
      };
    case GET_DATA_SOURCES:
      return {
        ...state,
      };
    case SET_DATA_INGESTION_WSCLIENT:
      return {
        ...state,
        wsClient: action.payload.wsClient,
      };
    case SET_INGESTION_DATA:
      return {
        ...state,
        ingestionData: [...action.payload.results],
      };
    case UPDATE_SUBMODULE_STATUS:
      return {
        ...state,
        subModuleStatus : action.payload.status,
      };
      case SET_MODULE_INFO:
        return {
          ...state,
          moduleInfo: {...action.payload.results},
        };
      case SET_USER_INFO:
          return {
            ...state,
            userInfo: {...action.payload.results},
          };
      case SET_AIRFLOW_USER_FLAG:
            return {
              ...state,
              airflowUserFlag: {...action.payload.results},
          };
      case SET_ACTIVE_MODULE:
        return {
          ...state,
          activeModule: action.payload.results,
        };
      case SET_INGESTION_PROCESS_SWITCH_STATUS:
        return {
          ...state,
          ingestionProcessSwitchFlag : action.payload.results,
        };
      case SET_INGESTION_SWITCH_STATUS:
          return {
            ...state,
            ingestionSwitchFlag : action.payload.results,
          };
      case SET_INGESTION_BUTTON:
        return {
          ...state,
          ingestionButton : action.payload.results,
        };
      case SET_INGESTION_FAILED_STATUS_FLAG:
        return {
          ...state,
          failedStatusFlag : action.payload.results,
        };
      case SET_INGESTION_PAUSE_STATUS_FLAG:
        return {
          ...state,
          pauseFlag : action.payload.results,
        };
      case SET_CONFIG_COMPLETED:
        return {
          ...state,
          configCompleted : action.payload.results,
        };  
      case SET_WORKFLOW_PANEL_FLAG:
        return {
          ...state,
          hideWorkflowPanel: action.payload.status,
        };
      default:
      return state;
  }
}
